import { render, staticRenderFns } from "./TableCells.vue?vue&type=template&id=9a480100&"
import script from "./TableCells.vue?vue&type=script&lang=js&"
export * from "./TableCells.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports